
import React from "react";
import { useAuth } from "@/context/AuthContext";

const CompanyBanner = () => {
  const { activeCompany } = useAuth();
  
  // Don't show banner - company switcher in header is enough
  return null;
};

export default CompanyBanner;
